export const iconFontAwesomeDesignFontAwesome = (
	<i className="fa-solid fa-font-awesome"></i>
);
